<template>
    <section id="pricing-plan">
        <!-- title text and switch button -->
        <h2 class="mt-5">Riepilogo</h2>
        <b-row v-if="pricing.length > 0">
            <b-col md="8">
                <b-card>
                    <b-row>
                        <b-col md="8">
                            <b-card-text><strong>{{ subscription_type.subscription_plan_name }}</strong></b-card-text>
                            <ul>
                                <li>
                                    <strong>Pacchetto: {{ subscription_type.package_code }}</strong><br>
                                    {{ subscription_type.package_description }}<br>
                                    Progetti Nuovi Impianti: {{ subscription_type.credit_installer }}<br>
                                    Progetti Manutenzione Impianti: {{ subscription_type.credit_mantainer }}

                                </li>
                                
                                
                                
                            </ul>
                            
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col md="4">
                <b-card>
                    <strong>Riepilogo importi</strong>
                    <hr />
                    <div class="d-flex justify-content-between">
                        <span>Prezzo</span>
                        <span>{{ priceFormatter.format(subscription_type.price) }} &euro;</span>
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between">
                        <span>Iva</span>
                        <span>{{ priceFormatter.format(subscription_type.price * 0.22) }} &euro;</span>
                    </div>
                    <hr />
                    <div class="d-flex justify-content-between">
                        <span><strong>Totale</strong></span>
                        <span><strong> {{ priceFormatter.format(subscription_type.price * 1.22) }} &euro;</strong></span>
                    </div>
                    <b-form class="mt-3 d-flex flex-column" style="gap: 30px">
                        <b-button class="flex-grow-1" variant="primary" @click="checkout">Paga con carta
                        </b-button>
                        
                        <b-button class="flex-grow-1" variant="primary" @click="checkout_bank_transfer">Paga con bonifico
                        </b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <form id="payment-nexi" action="" class="d-none" method="POST">

        </form>
    </section>

</template>

<script>
import {
    BRow, BCol, BCard, BCardText, BButton,
    BForm
} from 'bootstrap-vue'

import { Requests } from '@/api/requests';

export default {
    components: {
        BRow, BCol, BCard, BCardText, BButton, BForm
    },
    data: function () {
        return {
            id_package: null,
            pricing: [],
            priceFormatter: new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
            integerFormatter: new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0, minimumFractionDigits: 0 }),
        };
    },
    computed: {
        userData: function () {
            return JSON.parse(localStorage.getItem("user"));
        },
        subscription_type: function () {
            if (this.id_package) {
                const subscription = this.pricing.find(sub => sub.id_package == this.id_package);
                return subscription;
            } else {
                return {};
            }
        }
    },

    created() {
        this.id_package = this.$route.query.id_package;
        const self = this;
        this.getPricing().then(() => {
            if (!self.pricing.map(p => p.id_package).includes(self.id_package)) {
            self.$swal('Attenzione', 'Si è verificato un errore', 'error')
                .then(() => {
                    self.$router.push('/');
                })
        }

        });

    },
    methods: {
        
        async getPricing() {
            const response = await Requests.getPricing();
            this.pricing = response.data;
        },
        async checkout() {
            const fd = new FormData();
            fd.append('id_package', this.id_package);
            fd.append('type', 'card');
            try {
                const response = await Requests.checkout(fd);
                const form = document.getElementById('payment-nexi');
                form.setAttribute('action', response.XPAY_REQUEST_URL);
                for (const field of Object.keys(response)) {
                    if (field == 'XPAY_REQUEST_URL') continue;
                    const input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', field);
                    input.setAttribute('value', response[field]);
                    form.appendChild(input);
                }
                form.submit();
            } catch (e) {
                this.$swal('Attenzione', 'Si è verificato un errore, si prega di riprovare', 'error');
            }
        },
        async checkout_bank_transfer() {
            const fd = new FormData();
            fd.append('id_package', this.id_package);
            fd.append('type', 'bonifico');
            try {
                const response = await Requests.checkout(fd);
                this.$router.push({ name: 'order_success_bt' })
            } catch (e) {
                this.$swal('Attenzione', 'Si è verificato un errore, si prega di riprovare', 'error');
            }
        }
    },
}
</script>

